<template>
  <div>
    <!-- <div class="MuiContainer-root jss50 MuiContainer-maxWidthMd">
      <h2 class="MuiTypography-root jss51 fs-36 MuiTypography-alignCenter">{{artist.author}}</h2>
    </div>
    <div class="MuiContainer-root jss100 MuiContainer-maxWidthMd">
      <div class="MuiTypography-root jss51 fs-24">The TODAY Series of THE REMASTERED COLLECTION (TRC)</div>
      <div class="jss52">
        <div class="sc-iCfMLu eDTiIH">
          <div class="mb-4">World premier live exhibition at the Serbian Pavilion at the Dubai Expo 2020, starting on
            February 18 and ending on March 11, 2022.
          </div>
        </div>
      </div>
    </div> -->
    <div class="MuiContainer-root jss50 MuiContainer-maxWidthMd">
      <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 MuiGrid-justify-xs-center">
        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-10">
          <div class="MuiTypography-root fs-32 fw-700 text-center">{{artist.artistAuthor}}</div>
          <div class="MuiTypography-root jss100 fs-20">
            <a href="/#today" class="del-underline rainbow_underline" data-testid="item-detail-link">
              The TODAY Series of THE REMASTERED COLLECTION (TRC)
              </a>
          </div>
          <div class="jss52">
            <div class="mb-4">World premier live exhibition at the Serbian Pavilion at the Dubai Expo 2020, starting on
              February 18 and ending on March 11, 2022.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="MuiContainer-root jss53 mt-8 MuiContainer-maxWidthXl">
      <div class="jss54">
        <!-- 1. Yin Kun -->
        <div v-for="(artistWork,index) in artist.workList" :key="artistWork.id">
          <div class="jss56" data-testid="base-card">
            <div class="jss59">
              <router-link :to="'/' + artistWork.title" class="del-underline" data-testid="item-detail-link">
                <div class="jss57" v-if="artistWork.workType == 'video'">
                  <video :src="artistWork.work" autoplay="autoplay" loop="loop" muted="muted" bindended="EventHandle"
                    controls="false" controlsList="nodownload" width="480" height="100%"
                    style="pointer-events: none; position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; object-fit: cover; z-index: -1;">
                  </video>
                </div>
                <div class="jss57" v-if="artistWork.workType == 'image'">
                  <img :src="artistWork.work" alt=""
                    style="pointer-events: none; position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; object-fit: cover; z-index: -1;">
                </div>
                <div class="jss60">
                  <p class="MuiTypography-root jss62 MuiTypography-body1">{{artistWork.category}}</p>
                  <div class="jss63">
                    <p class="MuiTypography-root MuiTypography-body1 black--text">{{artistWork.nft}}</p>
                  </div>
                  <!--  <div class="jss102">
                    <p class="MuiTypography-root MuiTypography-body2 black--text">
                      {{artistWork.chart}}
                    </p>
                  </div> -->
                  <div class="jss65 mb-4">
                    <div class="MuiTypography-root MuiTypography-body2">{{artistWork.lastPrice}}</div>
                    <div class="MuiTypography-root MuiTypography-body2">
                    {{ '$' + $tools.formatNumber((artistWork.solValue * solPrice).toFixed(2)) }}
                    </div>
                  </div>
                </div>
              </router-link>
              <a class="MuiButtonBase-root MuiButton-root MuiButton-contained jss66 MuiButton-containedSizeLarge MuiButton-sizeLarge Mui-disabled Mui-disabled"
                tabindex="-1" role="button" aria-disabled="true" data-testid="purchase-link" href="#"><span
                  class="MuiButton-label">Details</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="MuiContainer-root jss100 MuiContainer-maxWidthMd">
      <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 MuiGrid-justify-xs-center">
        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-10">
          <div class="jss52">
            <div class="mb-4" v-html="artist.detail">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="MuiContainer-root jss100 MuiContainer-maxWidthMd">
      <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5 MuiGrid-justify-xs-center">
        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-8 MuiGrid-grid-md-10">
          <div class="d-flex flex-wrap justify-space-between">
            <!-- 上一页 -->
            <div>
              <div v-if="artistIndex > 0" class="pointer" @click="changeArtist(artistIndex - 1)">
                <v-icon size="24" class="mb-1">mdi-chevron-left</v-icon>
                <span class="blue--text">{{ artistList[artistIndex - 1].author }}</span>
              </div>
            </div>
            <!-- 下一页 -->
            <div>
              <div v-if="artistIndex < artistList.length - 1" class="pointer" @click="changeArtist(artistIndex + 1)">
                <span class="blue--text">{{ artistList[artistIndex + 1].author }}</span>
                <v-icon size="24" class="mb-1">mdi-chevron-right</v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import yinkun from "./data/yinkun.json"
  import yinjun from "./data/yinjun.json"
  import huangxi from "./data/huangxi.json"
  import liuyujun from "./data/liuyujun.json"
  import yangpeng from "./data/yangpeng.json"
  import liufei from "./data/liufei.json"
  import mayongqiang from "./data/mayongqiang.json"
  import { mapGetters } from "vuex";
  export default {
    data() {
      return {
        author: this.$route.params.author,
        artistList: [{
          id: '1',
          artistAuthor:'YIN KUN',
          author: 'Yin Kun',
          workList: yinkun,
          detail: "Yin Kun is a Chinese male contemporary artist born in Sichuan (CN) in 1969.<br /><br />Yin Kun’s first verified exhibition was Yin Kun - 'Chinese Fairy Tales' at Willem Kerseboom Modern & Contemporary Art in Amsterdam in 2006, and the most recent exhibition was Pop Austin International Art Show 2014 at POP AUSTIN in Austin, TX in 2014. Yin Kun is most frequently exhibited in Netherlands, but also had exhibitions in China, South Korea and elsewhere. Yin Kun has at least 3 solo shows and 12 group shows over the last 8 years. Yin Kun has also been in no less than one art fair but in no biennials. A notable show was Yin Kun - 'Chinese Fairy Tales' at Willem Kerseboom Modern & Contemporary Art in Amsterdam in 2006. Other notable shows were at Gallery LVS in Seoul and 34FineArt in Cape Town. Yin Kun has been exhibited with Jun Yin and Zhao Nengzhi.<br /><br /> Yi Kun spent his childhood amidst the most vehement class struggles. Although a mere child with no judgment on the merits of the ongoing struggles, Yi Kun was not immune to what was going on. Affected by the adult world and inspired by comic books, he was involuntarily involved in the vortex of class struggles and had amassed certain cultural memories of that typical age. That became the direct precursor of his subsequent series of \“Heroes\”. The Chinese like to call this kind of phenomena \“yin guo\” or \“cause and result\”. In post-modern life, a more obscure term has come to replace yin guo: metaphor. No matter what it is termed, be it \“yin guo\” or the post-modern \“metaphor\”, it attempts to expound a result attributable to events of the past. In fact, artistic creation has in it varied metaphors, most of which are associated to a varying extent with personal feelings and experiences.<br /><br />In fact, before the \“Heroes\” series, Yi Kun had started experimenting with a number of artistic styles such as boys and girls playing together, and video camera lens being boosted by soap bubbles etc. The youth motifs that these styles have at the very outset reflected the artistic pursuit of the artist: he wanted no social critique but rather the reconnaissance of the youth vigor and of the pleasures of childhood. That was in fact what he wanted to achieve through his \“Heroes\” series. The reason for his using the perspectives of comic books to reorganize his paintings was to deprive the heroic, severe images that are typical of heroes of their revolutionary background, and to reinvigorate them with a playful atmosphere like that of a game. The reason does not stem from his admiration for the heroes of the past, rather it is to recall the spirit of the heroic era, or in practical terms to revisit his own childhood.<br /><br />According to Artfacts, Yin Kun is among the \"Top 10,000\" artists in China. "
        }, {
          id: '2',
          artistAuthor:'YIN JUN',
          author: 'Yin Jun',
          workList: yinjun,
          detail: "Yin Jun is a chinese male artist born in Sichuan (CN) in 1974. He is the younger brother of Yin Kun.<br /><br />Yin Jun’s first verified exhibition was 'A Ticket to Beijing' at Willem Kerseboom Modern & Contemporary Art in Amsterdam in 2006, and the most recent exhibition was The Collection at Wellington Gallery in Hong Kong in 2014. Jun Yin is most frequently exhibited in Netherlands, but also had exhibitions in South Korea, Taiwan and elsewhere. Yin has at least 3 solo shows and 11 group shows over the last 8 years. A notable show was Yin Jun at Willem Kerseboom Modern & Contemporary Art in Amsterdam in 2007. Other notable shows were at 34FineArt in Cape Town and Willem Kerseboom Modern & Contemporary Art in Amsterdam. Jun Yin has been exhibited with Yin Kun and Liu Hui.<br /><br />Yin Jun’s work has been offered at auction multiple times, with realized prices ranging from $62 USD to $73,750 USD, depending on the size and medium of the artwork. Since 2006 the record price for this artist at auction is $73,750 USD for Family Series, sold at Kingsley Art Auction, Taipei in 2008.<br /><br />Yin Jun has been featured in articles for BBC News, ArtDaily and e-flux. The most recent article is When art collecting can mean big money written for BBC News in August 2011.<br /><br />According to Artfacts, Yin Jun is among the \"Top 10,000\" artists in China."
        }, {
          id: '3',
          artistAuthor:'HUANG XI',
          author: 'Huang Xi',
          workList: huangxi,
          detail: "In general, modern contemporary art moves forward along two lines: one is a formalistic presentation based on purely pictorial exploration, and the other is an expression of conceptual will in the context of the larger cultural form. The former actively explores formal innovation and breakthroughs, bravely breaking the boundaries of materials and media to seek greater expressive possibilities; the latter focuses on expressing human emotions, searching for philosophical reflections in the social landscape and humanistic spirit, injecting concepts in addition to the sense of form, and bringing a kind of criticism and reflection through a concrete view of the present. The latter focuses on expressing human emotions, finding philosophical reflections in social landscape and humanism, injecting concepts with a sense of form, and bringing a kind of criticism and reflection through a concrete view of the present.<br /><br /> His specific treatment of folds gives his paintings a sense of both figurative realism and a distinctly personal absurdity. Whether it's a paper-drenched feast, an aimless swing scene, or a wandering eagle on a rock, Huang Ruoxi's control of the image is very appropriate, and beneath the realistic surface, the \"folds\" bring about a spiritual crush and distortion of the soul, leading the viewer to the absurdity of the realistic context, thus reflecting the inner psychedelic situation of the present. It draws the viewer into the absurdity of the real context, thus reflecting the inner psychedelic situation of the present. This \"fold\" is not only the artist's unique creative language, but also the externalization of a kind of spiritual distortion, and the hedonistic scene of feasting and drinking further strengthens the inner expression of this distortion, materializing a certain reality, becoming a symbol, a mark, and a witness.<br /><br />In the artist's work, the master of power dominates everything, and whoever has the power can have magic like a wizard."
        }, {
          id: '4',
          artistAuthor:"LIU YUJUN",
          author: 'Liu YuJun',
          workList: liuyujun,
          detail: "Liu Yujun, born in 1963 in Shandong, China, and originally from Handan, Hebei, grew up in Gansu as a teenager, graduated from the art department of the Hebei Light Industry Management Institute in '89, and came to Beijing as a professional painter in 2001.<br /><br />After several years of exploring and defining his own artistic direction, He has participated in many domestic and international exhibitions and was invited to design the trophy and poster for the Belgium International Athletics Golden League in 2008."
        }, {
          id: '5',
          artistAuthor:"YANG PENG",
          author: 'Yang Peng',
          workList: yangpeng,
          detail: "Yang Peng was born in Sichuan, China in 1984, and has grown up experiencing the Chinese integration of modern and traditional culture. In 2012 he graduated from Sichuan Academy of Fine Arts, Chongqing, China with his M.F.A. His work has been widely exhibited internationally in solo and group exhibitions as well as International Art Fairs. Yang Peng lives and works in Sichuan, China."
        }, {
          id: '6',
          artistAuthor:"LIU FEI",
          author: 'Liu Fei',
          workList: liufei,
          detail: "Liu Fei is a young Chinese female artist born in 1983. She graduated from the Oil Painting Department of Sichuan Fine Arts Institute with a master's degree, and later earned Master of Fine Arts at Zurich University of the Arts in Switzerland.<br /><br />Artworks collected by: He Xiangning Art Museum, Today Art Museum, Chongqing Art Museum, Suzhou Art Museum, and TITONI Collection."
        }, {
          id: '7',
          artistAuthor:"MA YONGQIANG",
          author: 'Ma Yongqiang',
          workList: mayongqiang,
          detail: "Ma Yongqiang was born in Yantai, Shandong Province in 1971. He graduated from the Central Academy of Fine Arts. He now lives in Beijing. Ma Yongqiang is a gentle and introverted artist, but his works have a strong, spurting power.<br /><br />From his strict training in printmaking to his experimental exploration today, Ma Yongqiang has left behind two more mature series of works. One is the 'Cockscomb' series of oil paintings, and the other is the 'Flying Sand' series of mixed media works. His works have been exhibited in China, Taiwan, Hong Kong, Germany and the United States and are collected by important collectors."
        }],
      }
    },
    created() {

    },
    mounted() {

    },
    components: {},
    computed: {
      ...mapGetters(["solPrice"]),
      artist() {
        return this.artistList.filter(artist => artist.author.toLowerCase().replace(' ', '') == this.author
          .toLowerCase().replace(' ', ''))[0];
      },
      artistIndex() {
        return this.artistList.findIndex((artist, index) => artist.author.toLowerCase().replace(' ', '') == this.author
          .toLowerCase().replace(' ', ''));
      },
    },
    watch: {
      $route() {
        this.author = this.$route.params.author
      },
      author(newVal, oldVal) {
      }
    },
    methods: {
      changeArtist(index){
        this.$router.push({ name: 'Artist', params: { author: this.artistList[index].author.toLowerCase().replace(' ', '')} });
      }
    },
  }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/artist/Artist.vue